import { render, staticRenderFns } from "./AddEditReseller.vue?vue&type=template&id=68eb4114"
import script from "./AddEditReseller.vue?vue&type=script&lang=js"
export * from "./AddEditReseller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports